import en from './i18n-en.json';
import jp from './i18n-ja.json';
import cn from './i18n-zh.json';

export default { en, jp, cn };
